import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { queryClient } from '~shared/query-client';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store } from '~shared/store';
import { persistor } from '../persistor';
import { ErrorHandler } from '~shared/ui/error-handler/ui/error-handler';
import { logError } from '~shared/ui/error-handler/lib/log-error';
import { Toaster } from '@samera-one/ui';

export const AppProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorHandler} onError={logError}>
      <HelmetProvider>
        <ReduxProvider store={store}>
          <PersistGate persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <Toaster position="top-center" richColors />
              {/* {import.meta.env.DEV && (
                <ReactQueryDevtools
                  initialIsOpen={false}
                  buttonPosition="bottom-right"
                />
              )} */}
              {children}
            </QueryClientProvider>
          </PersistGate>
        </ReduxProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};
